import React from 'react'
import { CharacterCard } from '@components/CharacterCard'
import SelectPerPage from '@components/Pagination/components/SelectPerPage/SelectPerPage'
import { Pagination } from '@components/Pagination'
import CoinButton from '@components/CoinButton'
import { SocialSharing } from '@components/SocialSharing'
import { BASE_URL } from '@configs/config'
import { Loading } from '@components/Loading'
import { CharacterListProps } from './interface'
import { OptionForm } from '../OptionForm'

const perPageOptions = [20, 40, 60, 100, 300].map(value => ({
  label: String(value),
  value,
}))

export const CharacterList = ({
  initialValues,
  perpage,
  page,
  total,
  characterList,
  isLoading,
  handleSupportCharacter,
  handleSearch,
  perpageChange,
  handlePageChange,
}: CharacterListProps) => {
  return (
    <div>
      <div id='character-list' className='flex mb-[20px]'>
        <h1 className='font-mitr font-medium text-2xl text-secondary dark:text-primary'>
          ตัวละครทั้งหมด
        </h1>
      </div>
      <OptionForm initialValues={initialValues} handleSearch={handleSearch} />
      <div className='flex items-center justify-between mb-[11px]'>
        <span className='text-[14px] text-secondary-1 font-light'>
          <span className='mobile:hidden'>จำนวนตัวละคร :</span>
          <span className='font-mitr text-[16px] font-medium text-secondary dark:text-dark-10 uppercase'>
            {` ${total.toLocaleString()} `}
          </span>
          รายการ
        </span>

        <SelectPerPage
          value={perpage}
          options={perPageOptions}
          handleSelect={perpageChange}
        />
      </div>
      {isLoading ? (
        <div className='flex justify-center mt-[20px]'>
          <Loading />
        </div>
      ) : characterList.length > 0 ? (
        <>
          <div className='grid grid-cols-4 gap-[20px] py-[20px] justify-center mobile:gap-[10px] mobile:grid-cols-2 mobile:max-w-[375px] tablet:max-w-[664px] tablet-mobile:mx-auto  tablet:grid-cols-3'>
            {characterList.map(item => {
              return (
                <CharacterCard
                  className='border border-gray-4'
                  key={item.id}
                  id={String(item.id)}
                  bookId={item.book.id}
                  bookName={item.book.title}
                  imageUrl={item.resizeImgPath || item.imgPath}
                  rank={item.characterRank.name}
                  nextRank={item.characterNextRank?.name}
                  story={item.description}
                  name={item.name}
                  characterRole={item.characterRole.name}
                  coin={item.coinsTotal}
                  coinLeft={item.coinsToNextLevel}
                  characterRankStartCoins={item.characterRank.startCoins}
                  characterRankImg={item.characterRank.imgPath}
                  canViewStory
                  size='xs'
                >
                  <>
                    <hr className='text-gray-3 my-[9.5px] mobile:my-0' />
                    <div className='grid grid-cols-[1fr_30px] items-center gap-x-[10px]'>
                      <CoinButton
                        type='button'
                        disabled={!item.donatable}
                        className='w-full'
                        secondClassName='text-[16px] mobile:text-[12px] h-[30px]'
                        onClick={event => {
                          event.stopPropagation()
                          handleSupportCharacter(item)
                        }}
                        data-test='donate-character'
                        size={30}
                      >
                        สนับสนุน
                      </CoinButton>

                      <SocialSharing
                        shareUrl={`${BASE_URL}/share?characterId=${item.id}&bookId=${item.book.id}`}
                        bookId={item.book.id}
                      />
                    </div>
                  </>
                </CharacterCard>
              )
            })}
          </div>
          <div className='mt-[10px]'>
            <Pagination
              page={page}
              perpage={perpage}
              total={total}
              pageChange={handlePageChange}
            />
          </div>
        </>
      ) : (
        <div className='flex justify-center items-center py-[20px]'>
          <p className='font-mitr font-medium text-[24px] text-gray-11'>
            ไม่พบตัวละคร
          </p>
        </div>
      )}
    </div>
  )
}
